import { c as _c } from "react/compiler-runtime";
import { useSearchPageMapData } from "@/providers/search";
import type { Filters } from "@/types/filters";
import { useEffect, useRef } from "react";
interface UseTotalCountFetchParams {
  filters: Partial<Filters>;
  enabled?: boolean;
}

/**
 * Hook to fetch total count of properties based on filters
 * Automatically refetches when filters change
 * Uses network-only fetch to ensure fresh data
 */
export function useTotalCountFetch(t0) {
  const $ = _c(5);
  const {
    filters,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const abortControllerRef = useRef(null);
  const fetchTotalCount = useSearchPageMapData(_temp);
  let t2;
  let t3;
  if ($[0] !== enabled || $[1] !== fetchTotalCount || $[2] !== filters) {
    t2 = () => {
      if (!enabled) {
        return;
      }
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();
      fetchTotalCount({
        filters
      });
      return () => {
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
          abortControllerRef.current = null;
        }
      };
    };
    t3 = [filters, enabled, fetchTotalCount];
    $[0] = enabled;
    $[1] = fetchTotalCount;
    $[2] = filters;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
}
function _temp(state) {
  return state.fetchTotalCount;
}